import React from 'react'
import DinamicSelectComp from '../../../../../../common/DinamicSelectComp';
import DinamicInputFilter from '../../../../../../common/DinamicInputFilter';
import useVendors from '../../../../../../store/ReactQueries/procurements/vendors/useVendors';
import usePurchaseOrderTypes from '../../../../../../store/ReactQueries/procurements/purchaseOrderTypes/usePurchaseOrderTypes';
import { DataSelectType } from '../../../../../../models/DataSelectType';
import { getRecentYears } from '../../../../../../common/GlobalFunctions';
import { purchaseOrderStatusArrayWithIdAndTitle } from '../../../../../../enums/purchaseOrderStatus';

interface PurchaseOrderFilterProps {
    resetTrigger: number;
    filterData: DataSelectType[] | undefined;
    setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

export const PurchaseOrderFilter: React.FC<PurchaseOrderFilterProps> = ({ filterData, resetTrigger, setFilterData }) => {

    const { data: purchaseOrderTypes } = usePurchaseOrderTypes(0, 0);
    const { data: vendors } = useVendors(0, 0);

    const renderFilters: { fieldDisplayName: string, optionsData: any[] | undefined, menuPlacement?: "top" | "bottom"; }[] = [
        { fieldDisplayName: 'Year', optionsData: getRecentYears },
        { fieldDisplayName: 'PurchaseOrderType', optionsData: purchaseOrderTypes },
        { fieldDisplayName: 'Vendor', optionsData: vendors },
        { fieldDisplayName: 'PurchaseOrderStatus', optionsData: purchaseOrderStatusArrayWithIdAndTitle },
    ];

    return (
        <React.Fragment>
            <DinamicInputFilter
                field="code"
                fieldDisplayName="Code"
                filterData={filterData}
                setFilterData={setFilterData}
                resetTrigger={resetTrigger}
            />
            {
                renderFilters.map(item =>
                    <DinamicSelectComp
                        key={`${item.fieldDisplayName}-purchase-order-filter`}
                        fieldDisplayName={item.fieldDisplayName}
                        optionsData={item.optionsData}
                        filterData={filterData}
                        setFilterData={setFilterData}
                        resetTrigger={resetTrigger}
                        menuPlacement={item.menuPlacement}
                    />)
            }
        </React.Fragment>
    );
}
export default PurchaseOrderFilter